module.exports = __webpack_public_path__ + "img/zhewan1.1c8e5351.png";